import { render } from "./DocumentClassFieldsLayoutView.vue?vue&type=template&id=708a5c19&scoped=true&ts=true"
import script from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldsLayoutView.vue?vue&type=style&index=0&id=708a5c19&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708a5c19"]])

export default __exports__